/**
 * AI 分析 Modal - 主组件
 * 显示单个关键词的 AI 分析结果
 */

import React from 'react';
import { Modal, Spin } from 'antd';
import type { SingleAnalysisResult } from '../../types/ai-analysis-types';
import { AIProductInfo } from './components/AIProductInfo';
import { AIThinkingProcess } from './components/AIThinkingProcess';
import { AIDataSummary } from './components/AIDataSummary';
import { AIRecommendation } from './components/AIRecommendation';
import { AIInvestmentAnalysis } from './components/AIInvestmentAnalysis';
import { AISuccessPath } from './components/AISuccessPath';
import { AISuccessFactors } from './components/AISuccessFactors';
import { AIDataInsights } from './components/AIDataInsights';
import { AIRisks } from './components/AIRisks';
import './AIAnalysisModal.css';

interface AIAnalysisModalProps {
  visible: boolean;
  loading: boolean;
  analysisResult: SingleAnalysisResult | null;
  keywordName?: string;
  onClose: () => void;
}

const AIAnalysisModal: React.FC<AIAnalysisModalProps> = ({
  visible,
  loading,
  analysisResult,
  keywordName,
  onClose,
}) => {
  return (
    <Modal
      title={`智能分析: ${keywordName || '关键词'}`}
      open={visible}
      onCancel={onClose}
      width={1000}
      footer={null}
      destroyOnHidden
      className="ai-analysis-modal"
    >
      <Spin spinning={loading} tip="智能分析中，请稍候..." className="ai-loading-wrapper">
        {analysisResult && (
          <div>
            {/* SKU产品信息卡片 */}
            <AIProductInfo skuInfo={analysisResult.sku_info} />

            {/* AI思考过程（可折叠） */}
            <AIThinkingProcess thinkingProcess={analysisResult.thinking_process} />

            {/* 数据摘要看板 */}
            <AIDataSummary dataSummary={analysisResult.data_summary} />

            {/* 推荐决策 */}
            <AIRecommendation recommendation={analysisResult.recommendation} />

            {/* 投资分析 */}
            <AIInvestmentAnalysis investmentAnalysis={analysisResult.investment_analysis} />

            {/* 成功路径 */}
            <AISuccessPath successPath={analysisResult.success_path} />

            {/* 关键成功因素 */}
            <AISuccessFactors successFactors={analysisResult.key_success_factors} />

            {/* 数据洞察 */}
            <AIDataInsights dataInsights={analysisResult.data_insights} />

            {/* 风险提示 */}
            <AIRisks risks={analysisResult.risks} />
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export default AIAnalysisModal;
